<script>
  export let video = null;

  // Reactive statement to construct video URL when a video is selected
  $: highQualityVideoUrl = video ? `https://www.youtube.com/embed/${video.id}` : '';

  // Function to close the modal
  function closeModal() {
    video = null;
  }
</script>

{#if video}
  <div class="modal">
    <span class="close" on:click={closeModal}>&times;</span>
    <div class="video-container">
      <iframe src={highQualityVideoUrl} frameborder="0" allowfullscreen></iframe>
    </div>
  </div>
{/if}

<style>
.video-container {
  position: relative;
  /* Adjust width and height to desired viewport percentage or fixed size. */
  width: 90vw; /* 90% of the viewport width */
  height: 50vh; /* 50% of the viewport height */
  overflow: hidden;
}

.video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%; /* Make iframe fill the container width */
  height: 100%; /* Make iframe fill the container height */
  border: none;
}
</style>
